<script setup lang="ts">
const pointsActivities = [
	{
		name: 'for_a_start_on_the_app',
		subtextTranslated: 'plus_100_cars',
		icon: 'ticket-discount',
	},
	{
		name: 'each_1_pln_is_1_car',
		subtextTranslated: 'plus_1_cars',
		icon: 'ticket-discount',
	},
	{
		name: 'application_recommendation_and_first_rental',
		subtextTranslated: 'plus_500_cars',
		icon: 'ticket-discount',
	},
	{
		name: 'renting_a_premium_car',
		subtextTranslated: 'plus_150_cars',
		icon: 'ticket-discount',
	},
	{
		name: 'renting_an_electric_car',
		subtextTranslated: '20_cars_per_day',
		icon: 'ticket-discount',
	},
	{
		name: 'per_rental_for_6_10_days',
		subtextTranslated: 'plus_5_percent_cars',
		icon: 'ticket-discount',
	},
	{
		name: 'per_rental_for_11_15_days',
		subtextTranslated: 'plus_10_percent_cars',
		icon: 'ticket-discount',
	},
	{
		name: 'per_rental_for_15_plus_days',
		subtextTranslated: 'plus_15_percent_cars',
		icon: 'ticket-discount',
	},
]
</script>

<template>
	<section class="points-activities">
		<div class="points-activities__container">
			<h2 data-aos="fade-up" class="points-activities__title">
				{{ $t('modules.loyalty_program_module.loyalty_program_points_activities.exchange_points_for_points_activities') }}
			</h2>
			<div data-aos="fade-up" class="points-activities__items">
				<template v-for="(item, idx) in pointsActivities" :key="idx">
					<LoyaltyProgramRewardsReward
						:name="item.name"
						:subtext="item.subtext"
						:subtextTranslated="item.subtextTranslated"
						:icon="item.icon"
						:dark="true" />
				</template>
			</div>
		</div>
	</section>
</template>

<style scoped lang="scss">
@import './Activities.scss';
</style>
